import { useState, useEffect } from "react";
import CustomFormContainer from "../../../core/components/core/Util/Form/CustomForm/CustomFormContainer";
import CustomForm from "../../../core/components/core/Util/Form/CustomForm/CustomForm";
import Fetch from "../../../core/util/core/Fetch";
import { getUserSession } from "../../../core/util/core/Session";
import config from "../../config/config";
import sleep from 'sleep-promise';
import configApp from "../../config/config-app";

function Form() {

  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const [form,setForm] = useState();
  const session = getUserSession();
  const [states, setStates] = useState();

  const pathBackEnd = 'core/configs/';
  const paths = {
    endpointSave: config.endpoints.backend + pathBackEnd + 'save',
    endpointGetByReference: config.endpoints.backend + pathBackEnd + 'getByReference',
    urlGoBack: '',
  }
  let hiddenValues = {
    reference: 'cities-config'
  };
  
  if(session.loggedUserInfo.application_instance_id){
    hiddenValues = {...hiddenValues, core_application_instance_id: session.loggedUserInfo.application_instance_id}
  }

  const labels = {
    labelTitleAdd: "Configurações Gerais"
  }

  const getForm = (values) => {
    let form = {
      validateOnChange: true,
      showGoBackButton: false,
      hiddenValues,
      fields: [
        session.user.application_profile_id === configApp.default_foreign_key.application_profile_id ? {
          name: 'core_application_instance_id',
          type: 'select',
          options: [],
          optionsEndpoint: {
            endpoint: config.endpoints.backend + 'core/applicationsinstances/getall',
            label: 'instance_name',
            value: 'id'
          },
          label: 'Instâncias',
          handleChange: async (element,field,values) => {
            values.states = [];
            values.cities = [];
            let form = getForm(values);
            
            const configs = await Fetch.post(paths.endpointGetByReference, {
              core_application_instance_id: values.core_application_instance_id,
              reference: 'cities-config'
            });

            if(configs.config){
              values.states = configs.config.states;
              values.cities = configs.config.cities;
              form.fields[2].readOnly = values.states.length === 0;
              form.fields[2].optionsEndpoint.params.filter.where.states = values.states;
            }

            setForm(values);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(
            <CustomFormContainer 
                form = {form}
                content = {<CustomForm form={form}/>}
            />)
          },
          validations: {
            required: true
          },
          columnSize: 12
        } : {},
        {
          name: 'states',
          type: 'multiselect',
          options: [],
          optionsEndpoint: {
            endpoint: config.endpoints.backend + 'governanceroom/states/getall',
            label: 'geografic_state_name',
            value: 'geografic_state_id'
          },
          label: 'Estados',
          handleChange: async (element,field,values) => {
            const verifyStates = values.states.length === 0;
            values.cities = verifyStates ? [] : values.cities; 
            let form = getForm(values);
            form.fields[2].autoFocus = verifyStates;
            form.fields[2].readOnly = verifyStates;
            
            const cities = await Fetch.post(config.endpoints.backend + 'governanceroom/cities/getall', {
              filter: {
                where: {
                  states: values.states
                }
              }
            });

            values.cities = values.cities.filter(CityId =>
                cities.some(City => City.city_id === CityId)
            );
            
            setForm(values);
            setFormContent(<></>);
            await sleep(1);
            setFormContent(
            <CustomFormContainer 
                form = {form}
                content = {<CustomForm form={form}/>}
            />)
          },
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'cities',
          type: 'multiselect',
          options: [],
          readOnly: true,
          optionsEndpoint: {
            endpoint: config.endpoints.backend + 'governanceroom/cities/getallwithstate',
            label: 'city_name',
            value: 'city_id',
            params: {
              filter: {
                  where: {
                      states: values.states
                  }
              }
            }
          },
          label: 'Municípios',
          validations: {
            required: true
          },
          columnSize: 12
        },
      ],
      ...paths,
      ...labels
    }
    form.values = values;
    return form;
  }

  useEffect(() => {
    const load = async () => {
      let values = {};
      if(!(session.user.application_instance_id === configApp.default_foreign_key.application_instance_id)){
        try {
          let data = {
            core_application_instance_id: session.user.application_instance_id,
            reference: 'cities-config'
          }
          if(session.loggedUserInfo.application_instance_id){
            data.core_application_instance_id = session.loggedUserInfo.application_instance_id;
          }

          const response = await Fetch.post(paths.endpointGetByReference, data);
          
          values = response.config || {};
          
        } catch (error) {
          console.error("Erro durante a execução da função load:", error);
        }
      }
      const form = getForm(values);

      if(values.cities) {
        form.fields[2].readOnly = false;
      }
      setFormContent(
        <CustomFormContainer
          form={form}
          content={<CustomForm form={form} />} />
      );
    }
    load();
  }, [])

  return (
    <div>
      {formContent}
    </div>
  );
}
export default Form;